import React, { useEffect, useState } from "react";
import styles from "./categoryMgmt.module.scss";
import CustomButton from "../../components/customComponents/customButton/CustomButton";
import { GenCustomTable } from "../../components/customComponents/genCustomTable/GenCustomTable";
import {
  Avatar,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
} from "@mui/material";
import { useS3Upload } from "../../customHooks/S3Upload";
import OutlinedButton from "../../components/customComponents/outlinedButton/OutlinedButton";
import StatusCard from "../../components/uiComponents/statusCard/StatusCard";
import { connect, useDispatch } from "react-redux";
import EditIcon from "@mui/icons-material/Edit";
import CropImageUpload from "../../components/customComponents/manageBlog/CropImageUpload";
import {
  createCategory,
  getAllCategory,
  getCategoryByIdResponse,
  updateCategory,
} from "../../store/actions";
import { DESTINATIONS } from "../../utils/common/constants";
const columns = [
  {
    id: 1,
    label: "S.NO",
    minWidth: 120,
    align: "center",
  },
  {
    id: 2,
    label: "Image",
    minWidth: 170,
    align: "center",
  },
  {
    id: 3,
    label: "Category ID",
    minWidth: 170,
    align: "center",
  },
  {
    id: 4,
    label: "Name",
    minWidth: 170,
    align: "center",
  },
  {
    id: 5,
    label: "Status",
    minWidth: 170,
    align: "center",
  },
  {
    id: 6,
    label: "Action",
    minWidth: 170,
    align: "center",
  },
];

const CategoryMgmt = ({ categories = [], category = {} }) => {
  const dispatch = useDispatch();

  const [filteredData, setFilteredData] = useState([]);
  const [searched, setSearched] = useState("");
  const [open, setOpen] = useState(false);
  const [, uploadImages] = useS3Upload();
  const [values, setValues] = useState({});
  const [viewOpen, setViewOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [imagePreviewUrl, setImagePreviewUrl] = useState("");
  const [imageUploading, setImageUploading] = useState(false);

  useEffect(() => {
    dispatch(getAllCategory());
  }, []);

  const handleEdit = (item = {}) => {
    setOpen(true);
    dispatch(getCategoryByIdResponse(item));
    setValues({
      id: item?.id,
      imageUrl: item?.imageUrl,
      name: item?.name,
      description: item?.description,
      status: item?.status?.toString(),
    });
    setImagePreviewUrl(item?.imageUrl || "");
  };
  const handleView = (item) => {
    if (item?.imageUrl) {
      setSelectedImage(item.imageUrl);
      setViewOpen(true);
    }
  };

  const handleAddCategory = () => {
    resetForm();
    setOpen(true);
  };

  const resetForm = () => {
    setValues({});
    setImagePreviewUrl("");
    setImageUploading(false);
  };


  const getStructuredRows = (data = []) => {
    const structuredRows = data?.map((item, idx) => ({
      id: item?.id,
      rColumns: [
        idx + 1,
        <div className={styles.imgtable}>
          <Button
            variant="outlined"
            className={styles.ovalButtonOut}
            disableRipple
            disableElevation
            onClick={() => handleView(item)}
          >
            View
          </Button>

        </div>,
        item?.id,
        item?.name,
        item?.status === 1 ? (
          <Button
            variant="contained"
            className={styles.ovalButton3}
            disableRipple
            disableElevation
          >
            Active
          </Button>
        ) : (
          <Button
            variant="contained"
            className={styles.ovalButton4}
            disableRipple
            disableElevation
          >
            Inactive
          </Button>
        ),
        <div className={styles.imgtable} onClick={() => handleEdit(item)}>
          <EditIcon color="primary" />
          EDIT
        </div>,
      ],
    }));

    return structuredRows;
  };
  const getData = (input, data) => {
    const dataFilter = data?.filter((item) =>
      item?.name?.toLowerCase().includes(input?.toLowerCase())
    );
    if (dataFilter?.length > 0) {
      setFilteredData(dataFilter);
    } else {
      setFilteredData(null);
    }
  };

  const handleSearch = (value) => {
    setSearched(value);
    if (value.trim() === "") {
      setFilteredData([]);
    } else {
      const filtered = categories.filter((item) =>
        item?.name?.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredData(filtered);
    }
  };

  const handleClose = () => {
    setOpen(false);
    resetForm();
  };

  const handleInputChange = (key, value) => {
    setValues((prev) => {
      const updatedValues = {
        ...prev,
        [key]: value,
      };
      console.log("Updated values:", updatedValues);
      return updatedValues;
    });
  };

  const handleCroppedImage = async ({ dataUrl, file }) => {
    setImagePreviewUrl(dataUrl || "");
    if (!file) return;
    setImageUploading(true);
    try {
      const uploadUrl = await uploadImages(
        "categoryImage",
        file,
        DESTINATIONS?.CATEGORY_DETAILS
      );
      if (uploadUrl) {
        handleInputChange("imageUrl", uploadUrl);
      } else {
        handleInputChange("imageUrl", "");
        setImagePreviewUrl("");
      }
    } finally {
      setImageUploading(false);
    }
  };

  const handleClearImage = () => {
    setImagePreviewUrl("");
    handleInputChange("imageUrl", "");
  };

  const handleSuccess = () => {
    setOpen(false);
    resetForm();
    dispatch(getAllCategory());
  };

  const handleSaveChanges = () => {
    const payload = {
      name: values?.name,
      status: Number(values?.status),
      imageUrl: values?.imageUrl,
      description: values?.description,
    };

    if (values?.id) {
      dispatch(
        updateCategory({
          payload: {
            ...category,
            ...payload,
          },
          callback: { success: () => handleSuccess() },
        })
      );
    } else {
      dispatch(
        createCategory({
          payload: payload,
          callback: { success: () => handleSuccess() },
        })
      );
    }
  };

  const isFormModified = () => {
    const hasChanges =
      values?.name !== category?.name ||
      values?.imageUrl !== category?.imageUrl ||
      values?.description !== category?.description ||
      values?.status?.toString() !== category?.status?.toString();

    const isValid =
      values?.name && values?.imageUrl && values?.status && values?.description;

    return values?.id ? (!hasChanges ? hasChanges : isValid) : isValid;
  };

  return (
    <div className={styles.container}>
      <StatusCard
        leftContent="CATEGORIES" // or any icon/component
      />
      <div className={styles.wrapper}>
        <div className={styles.topWrapper}>
          <div className={styles.top}></div>
          <div className={styles.search}>
            {/* <SearchInput placeholder="Search category name" onSearch={handleSearch} /> */}
            {/* <Button
              variant="outlined"
              startIcon={<FilterAltOutlinedIcon />}
              className={styles.filterButton}
            >
              Filter
            </Button> */}
            <CustomButton
              title={"Add"}
              txtClr={"#FFFFFF"}
              background={"black"}
              width={"141px"}
              height={"48px"}
              borderRadius={"12px"}
              onClick={handleAddCategory}
            // onClick={() => handleNavigate()}
            />
          </div>
        </div>
        <div className={styles.bottom}>
          <GenCustomTable
            columns={columns}
            rows={getStructuredRows(
              searched.trim() ? filteredData : categories
            )}
          />
        </div>
      </div>
      <Dialog
        classes={{ root: styles.dialog }}
        PaperProps={{
          sx: {
            borderRadius: "16px",
          },
        }}
        open={open}
        onClose={handleClose}
      >
        <DialogTitle id="responsive-dialog-title">
          {values?.id ? (
            <div className={styles.title}>Edit Category</div>
          ) : (
            <div className={styles.title}>Add Category</div>
          )}
        </DialogTitle>
        <DialogContent classes={{ root: styles.dialogContainer }}>
          <div className={styles.dialogContent}>
            <div className={styles.imageUploadRow}>
              <Avatar
                variant="rounded"
                src={imagePreviewUrl || values?.imageUrl || ""}
                alt="Category preview"
                className={styles.imagePreview}
              >
                {!imagePreviewUrl && !values?.imageUrl ? "1:1" : ""}
              </Avatar>
              <div className={styles.imageUploadControls}>
                <FormControl fullWidth margin="none">
                  <InputLabel htmlFor="uploaded-image-name">
                    Upload Image*
                  </InputLabel>
                  <OutlinedInput
                    id="uploaded-image-name"
                    label="Upload Image"
                    sx={{ borderRadius: "12px" }}
                    value={values?.imageUrl || ""}
                    readOnly
                    disabled
                  />
                </FormControl>
                <CropImageUpload
                  aspect={1}
                  cropSize={{ width: 800, height: 800 }}
                  onCropped={handleCroppedImage}
                  onClear={handleClearImage}
                />
                <div className={styles.uploadHint}>
                  {imageUploading
                    ? "Uploading cropped image..."
                    : "Upload JPG or PNG and crop to 1:1."}
                </div>
              </div>
            </div>

            {values?.id && (
              <FormControl fullWidth margin="none">
                <InputLabel htmlFor="Category Id">Category ID</InputLabel>
                <OutlinedInput
                  fullWidth
                  id="Category ID"
                  sx={{ borderRadius: "12px" }}
                  label="Category ID"
                  disabled
                  value={values?.id}
                  onChange={(e) => handleInputChange("id", e.target.value)}
                />
              </FormControl>
            )}

            <FormControl fullWidth margin="none">
              <InputLabel htmlFor="Category Name">Category Name*</InputLabel>
              <OutlinedInput
                fullWidth
                focused={values?.name ? true : false}
                id="Category Name"
                sx={{ borderRadius: "12px" }}
                label="Category Name"
                value={values?.name}
                onChange={(e) => handleInputChange("name", e.target.value)}
              />
            </FormControl>

            <FormControl fullWidth margin="none">
              <InputLabel htmlFor="Redirect URL">Description*</InputLabel>
              <OutlinedInput
                fullWidth
                focused={values?.description ? true : false}
                id="Description"
                sx={{ borderRadius: "12px" }}
                label="Description"
                value={values?.description}
                onChange={(e) =>
                  handleInputChange("description", e.target.value)
                }
              />
            </FormControl>

            <FormControl fullWidth margin="none">
              <InputLabel id="status-label">Status*</InputLabel>
              <Select
                labelId="status-label"
                id="Status"
                sx={{ borderRadius: "12px" }}
                value={values?.status} // assuming 'status' is the correct key
                label="Status"
                onChange={(e) => handleInputChange("status", e.target.value)}
              >
                <MenuItem value="1">Active</MenuItem>
                <MenuItem value="0">Inactive</MenuItem>
              </Select>
            </FormControl>
          </div>
        </DialogContent>

        <DialogActions>
          <OutlinedButton
            title={"Close"}
            txtClr={"hsla(187, 98%, 16%, 1)"}
            border={"1px solid hsla(187, 98%, 16%, 1)"}
            width={"90px"}
            height={"34px"}
            borderRadius={"12px"}
            disabled={Object.keys(values)?.length === 0}
            onclick={handleClose}
          />
          <CustomButton
            title={"OK"}
            txtClr={"#FFFFFF"}
            background={!isFormModified() ? "grey" : "hsla(187, 98%, 16%, 1)"}
            width={"90px"}
            height={"34px"}
            borderRadius={"12px"}
            disabled={!isFormModified()}
            onClick={handleSaveChanges}
          />
        </DialogActions>
      </Dialog>
       {/* modal for view images */}
      <Dialog
        open={viewOpen}
        onClose={() => setViewOpen(false)}
        maxWidth="md"
        classes={{ paper: styles.dialogPaper }}
      >
        <DialogTitle className={styles.dialogHeader}>
          <span></span>
          <IconButton onClick={() => setViewOpen(false)} className={styles.closeButton}>
            ✕
          </IconButton>
        </DialogTitle>

        <DialogContent className={styles.dialogContents}>
          {selectedImage ? (
            <img src={selectedImage} alt="Category" className={styles.dialogImage} />
          ) : (
            <p>No image available</p>
          )}
        </DialogContent>
      </Dialog>  
     {/* modal for view images */}

    </div>
  );
};

const mapStateToProps = (state, props) => {
  return {
    categories: state?.category?.categories,
    category: state?.category?.category,
  };
};

export default connect(mapStateToProps, null)(CategoryMgmt);
